/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-sedan-2c55c1c0--sprite",
  "use": "car-sedan-2c55c1c0--sprite-usage",
  "viewBox": "0 0 51 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 51 21\" id=\"car-sedan-2c55c1c0--sprite\"><path d=\"M8 8H2.28a1 1 0 00-.97 1.243l1.5 6a1 1 0 00.97.757H8m0-8l8-7M8 8h7m1-7l-1 7m1-7h9.5M38 8h7a5 5 0 015 5v2a1 1 0 01-1 1h-5m-6-8l-7.717-6.753A1 1 0 0029.624 1H25.5M38 8H25.5M44 16a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H16m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m7-8h10.5m0 0V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M25.5 8H15l3 6h7.5m0-6H38l-4 6h-8.5m0-6v6m-24-4H4v2H2m48-1h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
